import axiosInstance from 'core/network/axiosInstance'

export interface KycApiResponse {
  id: string
  user_id: string
  business_name: string
  proprietor_name: string
  phone: string
  email?: string
  pan_last4: string
  gstin_last4: string
  has_pan_doc: boolean
  has_gstin_doc: boolean
  verified: boolean
  verified_by?: string
  verified_at?: string
  rejected: boolean
  rejected_by?: string
  rejected_at?: string
  rejection_reason?: string
  consent_given_at?: string
  created_at: string
  updated_at: string
}

export interface KycListApiResponse {
  skip: number
  limit: number
  total: number
  data: KycApiResponse[]
}

export interface GetKycRequestsApiParams {
  skip: number
  limit: number
  pending?: boolean
  verified?: boolean
  rejected?: boolean
}

export interface KycSensitiveApiResponse {
  id: string
  user_id: string
  name: string
  phone: string
  email: string
  address: string
  pan: string
  gstin: string
}

export interface DocumentUrlApiResponse {
  url: string
  expires_in: number
  doc_type: string
}

class KycApiDatasource {
  async getKycRequests(params: GetKycRequestsApiParams): Promise<KycListApiResponse> {
    const { data } = await axiosInstance.get<KycListApiResponse>('/api/v1/kyc/requests', { params })
    return data
  }

  async getSensitiveDetails(kycId: string): Promise<KycSensitiveApiResponse> {
    const { data } = await axiosInstance.get<KycSensitiveApiResponse>(`/api/v1/kyc/requests/${kycId}/sensitive`)
    return data
  }

  async getDocumentUrl(kycId: string, docType: string): Promise<DocumentUrlApiResponse> {
    const { data } = await axiosInstance.get<DocumentUrlApiResponse>(`/api/v1/kyc/requests/${kycId}/document`, {
      params: { type: docType },
    })
    return data
  }

  async verifyKyc(kycId: string): Promise<KycApiResponse> {
    const { data } = await axiosInstance.post<KycApiResponse>(`/api/v1/kyc/requests/${kycId}/verify`, {
      verified: true,
    })
    return data
  }

  async rejectKyc(kycId: string, reason: string): Promise<KycApiResponse> {
    const { data } = await axiosInstance.patch<KycApiResponse>(`/api/v1/kyc/requests/${kycId}/reject`, { reason })
    return data
  }
}

export const kycApiDatasource = new KycApiDatasource()
